import type { CollaboratorRole } from "~/types/collaborator-role";

export const getRoleDisplayName = (role: CollaboratorRole | null): string => {
  if (!role) {
    return "Collaborator";
  }

  const roleMap: Record<CollaboratorRole, string> = {
    AUTHOR: "Author",
    CO_AUTHOR: "Co-author",
    COVER_ILLUSTRATOR: "Cover illustrator",
    INTERNAL_ILLUSTRATOR: "Illustrator for the internal drawings and figures",
    INTERNAL_PHOTOGRAPHER: "Photographer for the internal photos",
    TRANSLATOR: "Translator",
    COLLECTIONS_EDITOR: "Collections editor",
    FOREWORD: "Foreword writer",
    GHOST_WRITER: "Ghost writer",
    PRODUCER: "Producer",
    COVER_ART_DESIGNER: "Cover art designer",
  };

  return roleMap[role] || "Collaborator";
};

export const getRolesDisplayName = (
  roles: CollaboratorRole[] | null
): string => {
  if (!roles || roles.length === 0) return "Collaborator";
  const names = roles.map((r) => getRoleDisplayName(r));
  if (names.length === 1) return names[0]!;
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
};
